import './App.css';
import Navbar from './components/navbar/Navbar';
import Banner from './components/banner/Banner';
import PlayerForm from './components/form/PlayerForm';
import { useEffect, useState } from 'react';
function App() {
  const [howToText, setHowToText] = useState(null);

  useEffect(() => {
    fetch('/bodyText.json')
      .then(res => res.json())
      .then(setHowToText);
  }, []);
  return (
    <div className="App">
      <Navbar />
      <Banner />
      <PlayerForm />
      <div className='container' style={{
        width:"100%",
        margin:"auto",
        textAlign:"left"
      }}>
        <br/> <br/>
        <hr/>
      {howToText && (
          <>
            <h2 className="my-3 text-center">{howToText.howToTitle}</h2>
            <div dangerouslySetInnerHTML={{__html: howToText.howToBody}} />
          </>
        )}
      </div>
<br/> <br/>
      <ins class="my-3 adsbygoogle"
     style={{"display":"block"}}
     data-ad-client="ca-pub-6615141629252034"
     data-ad-slot="9341265136"
     data-ad-format="auto"
     data-full-width-responsive="true"></ins>

      <div className='container' style={{
        width:"95%",
        margin:"auto",
        textAlign:"left"
      }}>
       {howToText && (
          <>
            <h3 className="text-center">{howToText.typesTitle}</h3>
            <div dangerouslySetInnerHTML={{__html: howToText.typesBody}} />
          </>
        )}
      </div>
<ins class="adsbygoogle"
     style={{"display":"block"}}
     data-ad-client="ca-pub-6615141629252034"
     data-ad-slot="9341265136"
     data-ad-format="auto"
     data-full-width-responsive="true"></ins>
        <footer style={{
                      marginTop: "40px",
                      background: "#222",
                      color: "#fff",
                      padding: "20px 0",
                      textAlign: "center",
                      fontSize: "1.1rem",
                     
                  }}>
                     All Rights Reserved © DLS Card Creator by DLSKitUrl
                  </footer>
    </div>
  );
}

export default App;
